import {
  AppName,
  AyahPathUserGoal,
  DancebitUserGoal,
  FitmeUserGoal,
  LuvlyUserGoal,
  NutriWalkingUserGoal,
  NutrimateUserGoal,
  TRetentionFlowApps,
  UnsubscribeReason,
  WoofzUserGoal,
} from 'root-constants'

export const PAUSE_SUBSCRIPTION_OPTION_VALUES = {
  YES: 'yes',
  NO: 'no',
}

export const DISCOUNT_OFFER_REASONS: Record<
  TRetentionFlowApps,
  UnsubscribeReason[]
> = {
  [AppName.LUVLY]: [
    UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.DANCEBIT]: [
    UnsubscribeReason.TIMING_IS_NOT_RIGHT,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.HEALTH_PROBLEMS,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.NO_REASON,
    UnsubscribeReason.OTHER,
  ],
  [AppName.NUTRIMATE]: [
    UnsubscribeReason.DID_NOT_GET_WEIGHT_GOAL,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.DO_NOT_UNDERSTAND_PROGRAM,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.NUTRI_WALKING]: [
    UnsubscribeReason.DID_NOT_GET_WEIGHT_GOAL,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.DO_NOT_UNDERSTAND_PROGRAM,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.FITME]: [
    UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.WOOFZ]: [],
  [AppName.SPILIO]: [
    UnsubscribeReason.ACHIEVED_GOAL,
    UnsubscribeReason.TIMING_IS_NOT_RIGHT,
  ],
  [AppName.DEEPLY]: [
    UnsubscribeReason.ACHIEVED_GOAL,
    UnsubscribeReason.TIMING_IS_NOT_RIGHT,
  ],
  [AppName.AYAHPATH]: [
    UnsubscribeReason.DO_NOT_FEEL_CONNECTED_TO_CONTENT,
    UnsubscribeReason.TOO_EXPENSIVE,
    UnsubscribeReason.HARD_TO_STAY_CONSISTENT,
    UnsubscribeReason.NOT_SEE_SPIRITUAL_PROGRESS,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.ALREADY_LEARNED,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.MYGROWTH]: [
    UnsubscribeReason.ACHIEVED_GOAL,
    UnsubscribeReason.TIMING_IS_NOT_RIGHT,
  ],
  [AppName.TESTORA]: [
    UnsubscribeReason.TOO_EXPENSIVE,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
  [AppName.DUMKA]: [
    UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
    UnsubscribeReason.DIFFICULTIES,
    UnsubscribeReason.NO_RESULTS,
    UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
    UnsubscribeReason.NO_UPDATES,
    UnsubscribeReason.TECH_ISSUES,
    UnsubscribeReason.OTHER,
  ],
}

type TAppUserGoalsMap = {
  [AppName.LUVLY]: Record<LuvlyUserGoal, string>
  [AppName.DANCEBIT]: Record<DancebitUserGoal, string>
  [AppName.NUTRIMATE]: Record<NutrimateUserGoal, string>
  [AppName.NUTRI_WALKING]: Record<NutriWalkingUserGoal, string>
  [AppName.FITME]: Record<FitmeUserGoal, string>
  [AppName.WOOFZ]: Record<WoofzUserGoal, string>
  [AppName.AYAHPATH]: Record<AyahPathUserGoal, string>
}

export const USER_GOALS_MAP: TAppUserGoalsMap = {
  [AppName.LUVLY]: {
    [LuvlyUserGoal.WRINKLE_FREE_SKIN]: 'retention.userGoals.wrinklesFree',
    [LuvlyUserGoal.REDUCE_FACE_FAT]: 'retention.userGoals.reduceFat',
    [LuvlyUserGoal.BOTH_OPTIONS]: 'retention.userGoals.tightenedSkin',
    [LuvlyUserGoal.TIGHTEN_SKIN]: 'retention.userGoals.tightenedSkin',
  },
  [AppName.DANCEBIT]: {
    [DancebitUserGoal.STAY_FIT]: 'retention.userGoals.changingHabits',
    [DancebitUserGoal.LOSE_WEIGHT]: 'retention.userGoals.weightLoss',
  },
  [AppName.NUTRIMATE]: {
    [NutrimateUserGoal.LOSE_WEIGHT]: 'retention.userGoals.loseWeight',
    [NutrimateUserGoal.GET_FIT]: 'retention.userGoals.getFit',
    [NutrimateUserGoal.BUILD_HEALTHY_HABITS]:
      'retention.userGoals.changeHabits',
    [NutrimateUserGoal.GET_HEALTHY_HABITS]: 'retention.userGoals.changeHabits',
  },
  [AppName.NUTRI_WALKING]: {
    [NutriWalkingUserGoal.LOSE_WEIGHT]: 'retention.userGoals.loseWeight',
    [NutriWalkingUserGoal.IMPROVE_SELF_ESTEEM]:
      'retention.userGoals.improveSelfEsteem',
    [NutriWalkingUserGoal.DEVELOP_FLEXIBILITY]:
      'retention.userGoals.developFlexibility',
    [NutriWalkingUserGoal.IMPROVE_HEART_HEALTH]:
      'retention.userGoals.heartHealth',
    [NutriWalkingUserGoal.STAY_FIT]: 'retention.userGoals.stayFit2',
    [NutriWalkingUserGoal.REDUCE_STRESS]: 'retention.userGoals.reduceStress',
    [NutriWalkingUserGoal.GET_FIRM_AND_TONED]: 'retention.userGoals.getFirm',
  },
  [AppName.FITME]: {
    [FitmeUserGoal.WEIGHT]: 'retention.userGoals.weight',
    [FitmeUserGoal.MUSCLES]: 'retention.userGoals.gainMuscles',
    [FitmeUserGoal.HEALTH]: 'retention.userGoals.health',
    [FitmeUserGoal.FIT]: 'retention.userGoals.fit',
  },
  [AppName.WOOFZ]: {
    [WoofzUserGoal.BEHAVIOUR_PROBLEMS]: 'retention.userGoals.behaviourProblems',
    [WoofzUserGoal.NEW_TRICKS]: 'retention.userGoals.newTricks',
    [WoofzUserGoal.HOME_ADAPTATION]: 'retention.userGoals.homeAdaptation',
    [WoofzUserGoal.PREVENT_PROBLEMS]: 'retention.userGoals.preventProblems',
  },
  [AppName.AYAHPATH]: {
    [AyahPathUserGoal.UNDERSTAND_QURAN_BETTER]:
      'retention.userGoals.understandQuranBetter',
    [AyahPathUserGoal.CREATE_SPIRITUAL_HABITS]:
      'retention.userGoals.createSpiritualHabits',
    [AyahPathUserGoal.FIND_PEACE]: 'retention.userGoals.findPeace',
  },
}
